import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosInstance } from 'axios'

import { EapToHpiBannerStateResponse } from '@lyrahealth-inc/shared-app-logic/src/features/eligibility/types'

export const SET_EAP_HPI_BANNER_STATE_IS_LOADED = 'SET_EAP_HPI_BANNER_STATE_IS_LOADED'

export const fetchEapHpiBannerState = createAsyncThunk<
  EapToHpiBannerStateResponse,
  { userLyraId: string; axiosInstance: AxiosInstance }
>('eapHpiBanner/fetchState', async ({ userLyraId, axiosInstance }, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get<EapToHpiBannerStateResponse>(`/v1/user/${userLyraId}/eapHpiBannerData`)
    return response.data
  } catch (error: unknown) {
    if (error instanceof Error) {
      return rejectWithValue(error.message)
    }
    return rejectWithValue('Failed to fetch EAP HPI banner data')
  }
})

export const setEapHpiBannerStateIsLoaded = (value: boolean) => ({
  type: SET_EAP_HPI_BANNER_STATE_IS_LOADED,
  payload: value,
})

export const FETCH_EAP_HPI_BANNER_STATE_FULFILLED = fetchEapHpiBannerState.fulfilled.type
export const FETCH_EAP_HPI_BANNER_STATE_REJECTED = fetchEapHpiBannerState.rejected.type
